import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppInformationService, UtilityService } from 'app/core/core.module';
import { smoothlyMenu } from '../../app.helpers';
import { CommonModule } from '@angular/common';
import { DevExtremeModule } from 'devextreme-angular';
declare var jQuery: any;

@Component({
    selector: 'app-document-package',
    templateUrl: './document-package.component.html',
    styleUrls: ['./document-package.component.scss'],
    standalone: true,
    imports: [CommonModule, DevExtremeModule],
})
export class DocumentPackageComponent implements OnInit {
    data: any;
    filter: {
        email: string;
        userCode: string;
    };
    codeFilter: {
        email: string;
        budgetBox: string;
        birthDate: Date;
    };
    dateString: string;
    processing = false;
    validationGroup = 'mainValidation';
    codeFilterOptions: any;
    userCode: any;
    proposalInfo: any;
    voteClosed = false;
    screenHeight: number;
    screenWidth: number;
    canDiscuss = false;
    discussion: string;
    discussions: any;

    constructor(private utility: UtilityService, private appInfo: AppInformationService, private route: ActivatedRoute) {
        this.getScreenSize();
    }
    toggleNavigation(): void {
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
        // console.log(this.screenHeight, this.screenWidth);
    }

    async ngOnInit() {
        this.userCode = this.route.snapshot.params['userId'];
        this.appInfo.pleaseWaitShow();
        try {
            await this.getData();
        } catch (error) {}
        this.appInfo.pleaseWaitHide();
        if (this.screenWidth > 850) this.toggleNavigation();

    }

    async getData() {
        this.data = await this.utility.getReviewLinks(this.userCode);
    }

    async openReview(reviewId: any) {
        try {
            this.appInfo.pleaseWaitShow();
            const reviewFilename = await this.utility.viewLinkedDocument(this.userCode, reviewId) as any;
            if (reviewFilename) {
                // Create a temporary anchor element to trigger download/view
                const link = document.createElement('a');
                link.href = reviewFilename;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                
                // Try to determine if it's a PDF or document that should open in browser
                const isDocument = reviewFilename.toLowerCase().includes('.pdf') || 
                                 reviewFilename.toLowerCase().includes('.doc') || 
                                 reviewFilename.toLowerCase().includes('.docx');
                
                if (isDocument) {
                    // For documents, try to open in same tab on mobile for better compatibility
                    if (this.isMobile()) {
                        window.location.href = reviewFilename;
                    } else {
                        // On desktop, try new tab first, fallback to same tab
                        try {
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        } catch (e) {
                            window.location.href = reviewFilename;
                        }
                    }
                } else {
                    // For other files, always navigate in same tab
                    window.location.href = reviewFilename;
                }
            } else {
                console.error('No filename returned for review ID:', reviewId);
            }
        } catch (error) {
            console.error('Error opening review:', error);
        } finally {
            this.appInfo.pleaseWaitHide();
        }
    }

    private isMobile(): boolean {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
}
